import React from "react";

/**
 * @type {React.FC<{ questionCount: number }>}
 * @returns {React.JSX.Element} React function component
 */
function QuizStatus({ questionCount }) {
  return (
    <div className="fr-font-medium fr-text-lg fr-text-zinc-800">
      This Quiz has&nbsp;
      <strong className="fr-font-bold fr-underline fr-underline-offset-2">
        {questionCount}
      </strong>
      &nbsp;
      {questionCount > 1 ? `Questions` : `Question`}
    </div>
  );
}

export default QuizStatus;
